import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IconTechServiceInternetRegular, skinVars, Stack, Text3, useDialog } from '@telefonica/mistica';
import { IRootState } from '../../utils/store/model/store.model';
import { hideStopper } from '../../utils/store/features/user';

const GlobalStopper = () => {
    const { dialog } = useDialog();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isStopper: boolean =
        useSelector((state: { user: IRootState }) => {
            const { user } = state;
            const { isStopper } = user;
            return isStopper;
        }) ?? false;

    useEffect(() => {
        if (isStopper) {
            dialog({
                asset: <IconTechServiceInternetRegular color={skinVars.colors.brand} size={53} />,
                title: t('serviceNotAvaiable'),
                message: (() => {
                    return (
                        <Stack space={16}>
                            <Text3 light color={skinVars.colors.textSecondary}>
                                {`${t('stopperDescription')}`}
                            </Text3>
                        </Stack>
                    );
                })() as any,
                onAccept: () => {
                    dispatch(hideStopper());
                },
                onCancel: () => {
                    dispatch(hideStopper());
                },
                acceptText: t('buttonUnderstoodFeedback'),
            });
        }
    }, [isStopper]);

    return <></>;
};

export default GlobalStopper;
